<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<div class="dialog-title">
  <div>
    <ng-content></ng-content>
  </div>

  @if (!disableCloseButton) {
    <button ngfButton mode="icon" [mat-dialog-close]="dialogCloseResult" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
